import { IReducerFn } from 'context/type';
import { TReducerSuggestedTruckersExtension } from './suggestedTruckersExtension.type';

export const SuggestedTruckersExtensionReducer: IReducerFn<TReducerSuggestedTruckersExtension> = (state, { type }) => {
  switch (type) {
    case 'suggested_truckers_extension_loading':
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        hasError: false,
        isSuccess: false,
      };
    case 'suggested_truckers_extension_success':
      return {
        ...state,
        isSuccess: true,
        isFetching: false,
        isFetched: true,
      };
    case 'suggested_truckers_extension_error':
      return {
        ...state,
        hasError: true,
        isFetching: false,
        isFetched: true,
      };

    default:
      return state;
  }
};

SuggestedTruckersExtensionReducer.key = 'suggestedTruckersExtension';
SuggestedTruckersExtensionReducer.initialState = {
  isFetching: false,
  isFetched: false,
  isSuccess: false,
  hasError: false,
};

export default { SuggestedTruckersExtensionReducer };
